import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface AudanetCostEstimationChange {
  claimIdentifier: string;
  costEstimationId?: number;
}

@Injectable({ providedIn: 'root' })
export class AudanetWindowSyncService implements OnDestroy {

  private channel = new BroadcastChannel('audanet-cost-estimation-sync');
  private changes = new Subject<AudanetCostEstimationChange>();

  costEstimationChanged$: Observable<AudanetCostEstimationChange> = this.changes.asObservable();

  constructor(zone: NgZone) {
    this.channel.onmessage = (e: MessageEvent<AudanetCostEstimationChange>) =>
      zone.run(() => this.changes.next(e.data));
  }

  notifyCostEstimationChanged(change: AudanetCostEstimationChange) {
    this.channel.postMessage(change);
  }

  ngOnDestroy() {
    this.channel.close();
  }
}
